import { render, staticRenderFns } from "./redeem-balance.vue?vue&type=template&id=0635c0a4&scoped=true&"
import script from "./redeem-balance.vue?vue&type=script&lang=js&"
export * from "./redeem-balance.vue?vue&type=script&lang=js&"
import style0 from "./redeem-balance.vue?vue&type=style&index=0&id=0635c0a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0635c0a4",
  null
  
)

export default component.exports